// app/dipendente/dipendenti.js

(function () {
    'use strict';
    var controllerId = 'curriculum';
    angular.module('app').controller(controllerId, ['$rootScope', '$routeParams', '$filter', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', '$translate', curriculumFn]);

    function curriculumFn($rootScope, $routeParams, $filter, common, bDialog, $uibModal, datacontext, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 
        
        var vm = this;
        vm.title = 'Curricula';
        vm.view = 'list';       //Opzione list or detail
        vm.sectionMenu = sectionMenu.setSection(vm.title);                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.addDisabled = true;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.super = $rootScope.isAuthorized('SUPER');
        vm.personale = $rootScope.isAuthorized('PERSONALE');
        vm.showInfo = true;
        vm.showIstruzioni = true;
        vm.showFormazioni = true;
        vm.showCompetenzePersonali = true;
        vm.showCompetenzeLinguistiche = true;
        vm.showEsperienzeLavorative = true;
        vm.showDettaglioProgetti = true;
        vm.cvValido = true;
        vm.bApriTutti = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Nominativo', 'Matricola', 'Stato Curriculum', 'Data Aggiornamento'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };

        //Elenchi dettaglio
        vm.list.sezioni = [];        
        vm.list.profili = [];           //Profili orari del dipendente
        vm.list.profiloOre = [];        //Elenco profili orari generale
        vm.list.province = [];
        vm.list.comuni = [];

        vm.list.istruzioni = [];
        vm.list.formazioni = [];
        vm.list.competenzeTecniche = [];
        vm.list.competenzeDigitali = [];
        vm.list.lingue = [];
        vm.list.esperienzeLavorative = [];
        vm.list.progetti = [];
        vm.list.fasi = [];
        
        //Filtro
        vm.filter = {};
        vm.filter.stato = vm.fStato = 0;
        vm.filter.statoCV = vm.fStatoCV = -1;
        vm.filter.sezione = vm.fSezione = 0;
        vm.filter.ricerca = vm.fRicerca = '';
        
        //Metodi su interfaccia            
        vm.getRecord = getRecord;        
        vm.get = getRecord;  

        vm.getComuni = getComuni;

        vm.editAnagraficaDipendente = editAnagraficaDipendente;

        //Gestione esperienze lavorative
        vm.addEsperienzaLavorativa = addEsperienzaLavorativa;
        vm.deleteEsperienzaLavorativa = deleteEsperienzaLavorativa;
        vm.editEsperienzaLavorativa = editEsperienzaLavorativa;

        //Gestione dettaglio progetti
        vm.addProgetto = addProgetto;
        vm.deleteProgetto = deleteProgetto;
        vm.editProgetto = editProgetto;

        //Gestione istruzioni
        vm.addIstruzione = addIstruzione;
        vm.deleteIstruzione = deleteIstruzione;
        vm.editIstruzione = editIstruzione;

        //Gestione formazioni
        vm.addFormazione = addFormazione;
        vm.deleteFormazione = deleteFormazione;
        vm.editFormazione = editFormazione;

        //Gestione competenza tecnica
        vm.addCompetenzaTecnica = addCompetenzaTecnica;
        vm.deleteCompetenzaTecnica = deleteCompetenzaTecnica;
        vm.editCompetenzaTecnica = editCompetenzaTecnica;

        //Gestione competenza tecnica
        vm.addCompetenzaDigitale = addCompetenzaDigitale;
        vm.deleteCompetenzaDigitale = deleteCompetenzaDigitale;
        vm.editCompetenzaDigitale = editCompetenzaDigitale;

        //Gestione lingue
        vm.addLingua = addLingua;
        vm.deleteLingua = deleteLingua;
        vm.editLingua = editLingua;

        vm.stampaCV = stampaCV;
        vm.apriTutti = apriTutti;

        //Configurazione calendario
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        vm.format = 'dd/MM/yyyy';

        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;
            vm.opened1 = vm.opened2 = false;
        };

        vm.open1 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = !vm.opened1;
            vm.opened = vm.opened2 = false;
        };

        vm.open2 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened2 = !vm.opened2;
            vm.opened = vm.opened1 = false;
        };

        //Gestione Attach
        vm.fAttach = {};
        vm.filterAttach = '';
        vm.setfAttach = setfAttach;
        vm.list.attach = [];
        //vm.getListAttach = getListAttach;
        vm.tSourceCode_def = 'CUR';
        vm.addAttach = addAttach;
        vm.deleteAttach = deleteAttach;
        vm.addFirma = addFirma;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getTSource(vm.tSourceCode_def), getTAttach(vm.tSourceCode_def)];
            common.activateController(promises, controllerId)
                .then(function () {
                    getRecord($rootScope.id, 0);
                });
        }

        //****************************************************
        // METODI 
        //****************************************************

        function getRecord(id, index) {            
            vm.list.profili = [];

            if (!id)
                id = $rootScope.id ? $rootScope.id : 0;

            return datacontext.dipendente_get(id).then(function (data) {  
                vm.index = index;
                if (data && data != 400) {
                    if (data.ProvinciaId)
                        getComuni(data.ProvinciaId);

                    getEsperienzeLavorative(data.Id);
                    getDettaglioProgetti(data.Id);
                    getIstruzioni(data.Id);
                    getFormazioni(data.Id);
                    getCompetenzeDigitali(data.Id);
                    getCompetenzeTecniche(data.Id);
                    getLingue(data.Id);
                    getFasi(data.Id).then(function (fasi) {
                        vm.showInfo = !fasi[0].Completed;
                        vm.showIstruzioni = !fasi[3].Completed;
                        vm.showFormazioni = !fasi[4].Completed;
                        vm.showCompetenzePersonali = !fasi[5].Completed;
                        vm.showCompetenzeLinguistiche = !fasi[6].Completed;
                        vm.showEsperienzeLavorative = !fasi[1].Completed;
                        vm.showDettaglioProgetti = !fasi[2].Completed;
                    });

                    vm.cvValido = true;
                    vm.record = data;

                    if (vm.record.FirmaId == 0) {
                        $uibModal.open({
                            templateUrl: '/app/curriculum/modal/avvisoFirma.html?version=30',
                            controller: 'avvisoFirma'
                        });
                    }
                }
                else {
                    vm.cvValido = false;
                    logError($translate.instant('Errore nel caricamento del CV'));
                }   

                
            });
        }   

        function editAnagraficaDipendente() {
            var modalAnagrafica = {};
            angular.copy(vm.record, modalAnagrafica);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/anagraficaDipendenteEdit.html?version=30',
                controller: 'anagraficaDipendenteEdit',
                windowClass: 'modal-wide',
                resolve: {
                    anagraficaDipendente: function () {
                        return modalAnagrafica;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                getRecord(vm.record.Id);
            });
        }

        // Gestione esperienze lavorative
        function getEsperienzeLavorative(dipendenteId) {
            return datacontext.esperienzaLavorativa_getAll(dipendenteId).then(function (data) {
                return vm.list.esperienzeLavorative = data;
            });
        }

        function deleteEsperienzaLavorativa(item) {
            var msg = " " + $translate.instant('esperienza lavorativa') + " " + item.TipoMansione;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.esperienzaLavorativa_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));

                    var index = vm.list.esperienzeLavorative.indexOf(item);
                    var sequence = item.sequence;
                    vm.list.esperienzeLavorative.splice(index, 1);
                    vm.list.esperienzeLavorative.forEach(function (obj) {
                        if (obj.Sequence > sequence)
                            obj.Sequence--;
                    });
                    getFasi(vm.record.Id);
                });
            });
        }

        function changeSequenceEsperienzaLavorativa(orderList) {
            datacontext.esperienzaLavorativa_changeSequence(orderList).then(function (data) {
                if (data) {
                    logError($translate.instant('Impossibile salvare i dati'));
                } else
                    logSuccess($translate.instant('Ordinamento effettuato con successo'));
            });
        }

        function updateSequenceEsperienzaLavorativa() {
            var orderList = [];
            var sequence = 1;

            vm.list.esperienzeLavorative.forEach(function (item) {
                item.Sequence = sequence++;
                orderList.push(item.Id);
            });

            changeSequenceEsperienzaLavorativa(orderList);
        }

        vm.sortingLogEsperienzaLavorativa = [];

        vm.sortableOptionsEsperienzaLavorativa = {
            handle: "> .myHandle",
            update: function (e, ui) {
                var logEntry = vm.list.esperienzeLavorative.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLogEsperienzaLavorativa.push("Update: " + logEntry);
            },
            stop: function (e, ui) {
                // this callback has the changed model
                var logEntry = vm.list.esperienzeLavorative.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLogEsperienzaLavorativa.push("Stop: " + logEntry);
                updateSequenceEsperienzaLavorativa();
            }
        };

        function addEsperienzaLavorativa() {
            var modalEsperienzaLavorativa = {};
            modalEsperienzaLavorativa.Id = 0;
            modalEsperienzaLavorativa.DipendenteId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/esperienzaLavorativaAddEdit.html?version=30',
                controller: 'esperienzaLavorativaAddEdit',
                windowClass: 'modal-wide',
                resolve: {
                    esperienzaLavorativa: function () {
                        return modalEsperienzaLavorativa;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                logSuccess($translate.instant('Esperienza lavorativa aggiunta con successo'));
                getEsperienzeLavorative(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        function editEsperienzaLavorativa(item) {
            var modalEsperienzaLavorativa = {};
            angular.copy(item, modalEsperienzaLavorativa);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/esperienzaLavorativaAddEdit.html?version=30',
                controller: 'esperienzaLavorativaAddEdit',
                windowClass: 'modal-wide',
                resolve: {
                    esperienzaLavorativa: function () {
                        return modalEsperienzaLavorativa;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));

                logSuccess($translate.instant('Esperienza lavorativa modificata con successo'));
                getEsperienzeLavorative(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        // Gestione dettaglio progetti
        function getDettaglioProgetti(dipendenteId) {
            return datacontext.dettaglioProgetto_getAll(dipendenteId).then(function (data) {                
                return vm.list.progetti = data;
            });
        }

        function deleteProgetto(item) {
            var msg = " " + $translate.instant('il dettaglio relativo al progetto') + " " + item.Titolo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.dettaglioProgetto_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));

                    var index = vm.list.progetti.indexOf(item);
                    var sequence = item.sequence;
                    vm.list.progetti.splice(index, 1);
                    vm.list.progetti.forEach(function (obj) {
                        if (obj.Sequence > sequence)
                            obj.Sequence--;
                    });
                    getFasi(vm.record.Id);
                });
            });
        }

        function changeSequenceDettaglioProgetti(orderList) {
            datacontext.dettaglioProgetto_changeSequence(orderList).then(function (data) {
                if (data) {
                    logError($translate.instant('Impossibile salvare i dati'));
                } else
                    logSuccess($translate.instant('Ordinamento effettuato con successo'));
            });
        }

        function updateSequenceDettaglioProgetti() {
            var orderList = [];
            var sequence = 1;

            vm.list.progetti.forEach(function (item) {
                item.Sequence = sequence++;
                orderList.push(item.Id);
            });

            changeSequenceDettaglioProgetti(orderList);
        }

        vm.sortingLogDettaglioProgetti = [];

        vm.sortableOptionsDettaglioProgetti = {
            handle: "> .myHandle",
            update: function (e, ui) {
                var logEntry = vm.list.progetti.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLogDettaglioProgetti.push("Update: " + logEntry);
            },
            stop: function (e, ui) {
                // this callback has the changed model
                var logEntry = vm.list.progetti.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLogDettaglioProgetti.push("Stop: " + logEntry);
                updateSequenceDettaglioProgetti();
            }
        };

        function addProgetto() {
            var modalProgetto = {};
            modalProgetto.Id = 0;
            modalProgetto.DipendenteId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/dettaglioProgettoAddEdit.html?version=30',
                controller: 'dettaglioProgettoAddEdit',
                windowClass: 'modal-wide',
                resolve: {
                    progetto: function () {
                        return modalProgetto;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                logSuccess($translate.instant('Progetto aggiunto con successo'));
                getDettaglioProgetti(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        function editProgetto(item) {
            var modalProgetto = {};
            angular.copy(item, modalProgetto);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/dettaglioProgettoAddEdit.html?version=30',
                controller: 'dettaglioProgettoAddEdit',
                windowClass: 'modal-wide',
                resolve: {
                    progetto: function () {
                        return modalProgetto;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));

                logSuccess($translate.instant('Progetto modificato con successo'));
                getDettaglioProgetti(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        // Gestione istruzioni
        function getIstruzioni(dipendenteId) {
            return datacontext.istruzione_getAll(dipendenteId).then(function (data) {
                return vm.list.istruzioni = data;
            });
        }

        function deleteIstruzione(item) {
            var msg = " " + $translate.instant('istruzione con qualifica') + " " + item.Qualifica;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.istruzione_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));

                    var index = vm.list.istruzioni.indexOf(item);
                    var sequence = item.sequence;
                    vm.list.istruzioni.splice(index, 1);
                    vm.list.istruzioni.forEach(function (obj) {
                        if (obj.Sequence > sequence)
                            obj.Sequence--;
                    });
                    getFasi(vm.record.Id);
                });
            });
        }

        function changeSequenceIstruzioni(orderList) {
            datacontext.istruzione_changeSequence(orderList).then(function (data) {
                if (data) {
                    logError($translate.instant('Impossibile salvare i dati'));
                } else
                    logSuccess($translate.instant('Ordinamento effettuato con successo'));
            });
        }

        function updateSequenceIstruzioni() {
            var orderList = [];
            var sequence = 1;

            vm.list.istruzioni.forEach(function (item) {
                item.Sequence = sequence++;
                orderList.push(item.Id);
            });

            changeSequenceIstruzioni(orderList);
        }

        vm.sortingLogIstruzioni = [];

        vm.sortableOptionsIstruzioni = {
            handle: "> .myHandle",
            update: function (e, ui) {
                var logEntry = vm.list.istruzioni.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLogIstruzioni.push("Update: " + logEntry);
            },
            stop: function (e, ui) {
                // this callback has the changed model
                var logEntry = vm.list.istruzioni.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLogIstruzioni.push("Stop: " + logEntry);
                updateSequenceIstruzioni();
            }
        };

        function addIstruzione() {
            var modalIstruzione = {};
            modalIstruzione.Id = 0;
            modalIstruzione.DipendenteId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/istruzioneAddEdit.html?version=30',
                controller: 'istruzioneAddEdit',
                resolve: {
                    istruzione: function () {
                        return modalIstruzione;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                logSuccess($translate.instant('Istruzione aggiunta con successo'));
                getIstruzioni(vm.record.Id); 
                getFasi(vm.record.Id);
            });
        }

        function editIstruzione(item) {
            var modalIstruzione = {};
            angular.copy(item, modalIstruzione);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/istruzioneAddEdit.html?version=30',
                controller: 'istruzioneAddEdit',
                resolve: {
                    istruzione: function () {
                        return modalIstruzione;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la modifica del dato ');

                logSuccess($translate.instant('Istruzione modificata con successo'));
                getIstruzioni(vm.record.Id);  
                getFasi(vm.record.Id);
            });
        }

        // Gestione formazioni
        function getFormazioni(dipendenteId) {
            return datacontext.formazione_getAll(dipendenteId).then(function (data) {
                return vm.list.formazioni = data;
            });
        }

        function deleteFormazione(item) {
            var msg = " " + $translate.instant('la formazione con qualifica') + " " + item.Oggetto;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.formazione_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));

                    var index = vm.list.formazioni.indexOf(item);
                    var sequence = item.sequence;
                    vm.list.formazioni.splice(index, 1);
                    vm.list.formazioni.forEach(function (obj) {
                        if (obj.Sequence > sequence)
                            obj.Sequence--;
                    });
                    getFasi(vm.record.Id);
                });
            });
        }

        function changeSequenceFormazioni(orderList) {
            datacontext.formazione_changeSequence(orderList).then(function (data) {
                if (data) {
                    logError($translate.instant('Impossibile salvare i dati'));
                } else
                    logSuccess($translate.instant('Ordinamento effettuato con successo'));
            });
        }

        function updateSequenceFormazioni() {
            var orderList = [];
            var sequence = 1;

            vm.list.formazioni.forEach(function (item) {
                item.Sequence = sequence++;
                orderList.push(item.Id);
            });

            changeSequenceFormazioni(orderList);
        }

        vm.sortingLogFormazioni = [];

        vm.sortableOptionsFormazioni = {
            handle: "> .myHandle",
            update: function (e, ui) {
                var logEntry = vm.list.formazioni.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLogFormazioni.push("Update: " + logEntry);
            },
            stop: function (e, ui) {
                // this callback has the changed model
                var logEntry = vm.list.formazioni.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLogFormazioni.push("Stop: " + logEntry);
                updateSequenceFormazioni();
            }
        };

        function addFormazione() {
            var modalFormazione = {};
            modalFormazione.Id = 0;
            modalFormazione.DipendenteId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/formazioneAddEdit.html?version=30',
                controller: 'formazioneAddEdit',
                resolve: {
                    formazione: function () {
                        return modalFormazione;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                logSuccess($translate.instant('Formazione aggiunta con successo'));
                getFormazioni(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        function editFormazione(item) {
            var modalFormazione = {};
            angular.copy(item, modalFormazione);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/formazioneAddEdit.html?version=30',
                controller: 'formazioneAddEdit',
                resolve: {
                    formazione: function () {
                        return modalFormazione;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));

                logSuccess($translate.instant('Formazione modificata con successo'));
                getFormazioni(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        // Gestione competenze digitali
        function getCompetenzeDigitali(dipendenteId) {
            return datacontext.competenzaDigitale_getAll(dipendenteId).then(function (data) {
                return vm.list.competenzeDigitali = data;
            });
        }

        function deleteCompetenzaDigitale(item, index) {
            var msg = " " + $translate.instant('la competenza digitale') + " " + item.Competenza;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.competenzaDigitale_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));

                    vm.list.competenzeDigitali.splice(index, 1);
                    getFasi(vm.record.Id);
                });
            });
        }

        function addCompetenzaDigitale() {
            var modalCompentezaDigitale = {};
            modalCompentezaDigitale.Id = 0;
            modalCompentezaDigitale.DipendenteId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/competenzaDigitaleAddEdit.html?version=30',
                controller: 'competenzaDigitaleAddEdit',
                resolve: {
                    competenza: function () {
                        return modalCompentezaDigitale;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || returnItem == "500") return logError($translate.instant('Errore durante la creazione del dato'));

                logSuccess($translate.instant('Competenza digitale aggiunta con successo'));
                getCompetenzeDigitali(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        function editCompetenzaDigitale(item) {
            var modalCompentezaDigitale = {};
            angular.copy(item, modalCompentezaDigitale);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/competenzaDigitaleAddEdit.html?version=30',
                controller: 'competenzaDigitaleAddEdit',
                resolve: {
                    competenza: function () {
                        return modalCompentezaDigitale;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || returnItem == "500") return logError('Errore durante la modifica del dato ');

                logSuccess($translate.instant('Competenza digitale modificata con successo'));
                getCompetenzeDigitali(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        // Gestione competenze tecniche
        function getCompetenzeTecniche(dipendenteId) {
            return datacontext.competenzaTecnica_getAll(dipendenteId).then(function (data) {
                return vm.list.competenzeTecniche = data;
            });
        }

        function deleteCompetenzaTecnica(item, index) {
            var msg = " " + $translate.instant('la competenza tecnica') + " " + item.Competenza;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.competenzaTecnica_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));

                    vm.list.competenzeTecniche.splice(index, 1);
                    getFasi(vm.record.Id);
                });
            });
        }

        function addCompetenzaTecnica() {
            var modalCompentezaTecnica = {};
            modalCompentezaTecnica.Id = 0;
            modalCompentezaTecnica.DipendenteId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/competenzaTecnicaAddEdit.html?version=30',
                controller: 'competenzaTecnicaAddEdit',
                resolve: {
                    competenza: function () {
                        return modalCompentezaTecnica;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || returnItem == "500") return logError($translate.instant('Errore durante la creazione del dato'));

                logSuccess($translate.instant('Competenza tecnica aggiunta con successo'));
                getCompetenzeTecniche(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        function editCompetenzaTecnica(item) {
            var modalCompentezaTecnica = {};
            angular.copy(item, modalCompentezaTecnica);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/competenzaTecnicaAddEdit.html?version=30',
                controller: 'competenzaTecnicaAddEdit',
                resolve: {
                    competenza: function () {
                        return modalCompentezaTecnica;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || returnItem == "500") return logError('Errore durante la modifica del dato ');

                logSuccess($translate.instant('Competenza digitale modificata con successo'));
                getCompetenzeTecniche(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        // Gestione lingue
        function getLingue(dipendenteId) {
            return datacontext.lingua_getAll(dipendenteId).then(function (data) {
                return vm.list.lingue = data;
            });
        }

        function deleteLingua(item, index) {
            var msg = ' la lingua ' + item.Nome;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.lingua_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));

                    vm.list.lingue.splice(index, 1);
                    getFasi(vm.record.Id);
                });
            });
        }

        function addLingua() {
            var modalLingua = {};
            modalLingua.Id = 0;
            modalLingua.DipendenteId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/linguaAddEdit.html?version=30',
                controller: 'linguaAddEdit',
                resolve: {
                    lingua: function () {
                        return modalLingua;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || returnItem == "500") return logError($translate.instant('Errore durante la creazione del dato'));

                logSuccess($translate.instant('Lingua aggiunta con successo'));
                getLingue(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        function editLingua(item) {
            var modalLingua = {};
            angular.copy(item, modalLingua);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/linguaAddEdit.html?version=30',
                controller: 'linguaAddEdit',
                resolve: {
                    lingua: function () {
                        return modalLingua;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || returnItem == "500") return logError($translate.instant('Errore durante la modifica del dato'));

                logSuccess($translate.instant('Lingua modificata con successo'));
                getLingue(vm.record.Id);
                getFasi(vm.record.Id);
            });
        }

        //Fasi 
        function getFasi(dipendenteId) {
            return datacontext.faseCurriculum_getAll(dipendenteId).then(function (data) {
                if (data.length > 0) {
                    var stato = 0;
                    data.forEach(function (item) {
                        stato += item.Completed;
                    });
                    $rootScope.statoCV = stato;
                }

                return vm.list.fasi = data;
            });
        }

        function stampaCV() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/curriculum/modal/stampaCV.html?version=30',
                controller: 'stampaCV',
                resolve: {
                    dipendente: function () {
                        return vm.record;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                vm.loading = true;
                datacontext.dipendente_stampaCurriculum(vm.record.Id, returnItem.Attach, returnItem.Signature, returnItem.DataStampa, returnItem.Logo, returnItem.Address, returnItem.BusinessPhone, returnItem.MobilePhone, returnItem.Rev, returnItem.DataRev).then(function (data) {
                    if (data && data.url) {
                        var a = document.createElement("a");
                        a.setAttribute('style', 'display:none');
                        a.setAttribute("target", "_blank");
                        //var data_type = 'data:application/pdf';

                        document.body.appendChild(a);
                        a.href = data.url;
                        a.download = data.file;
                        a.click();
                        document.body.removeChild(a);

                        vm.loading = false;
                        getRecord(vm.record.Id);
                    }
                    else {
                        logError($translate.instant('Impossibile scaricare il file'));
                        vm.loading = false;
                    }
                });
            });
        }

        // List province e comuni
        function getProvince() {
            if (vm.list.province.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                vm.list.province = data;
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return vm.list.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.list.comuni = data;
            });
        }

        function apriTutti(value) {
            vm.showInfo = value;
            vm.showEsperienzeLavorative = value;
            vm.showDettaglioProgetti = value;
            vm.showIstruzioni = value;
            vm.showFormazioni = value;
            vm.showCompetenzePersonali = value;
            vm.showCompetenzeLinguistiche = value;
            vm.bApriTutti = !vm.bApriTutti;
        }







        //Gestione Attach
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }

        function getListAttach(id) {
            if (!id) return;

            return datacontext.attach_getAll(0, 0, vm.tSourceCode_def, 0, id, vm.fAttach.TAttachId, '').then(function (data) {
                vm.list.b_attach = true;
                return vm.list.attach = data;
            });
        }

        function addAttach(item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var recSource = { Id: vm.record.Id, Name: vm.record.Nominativo };

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/attach/modal/attachAdd.html?version=30',
                controller: 'attachAdd',
                windowClass: 'modal-wide',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        //return null;
                        return vm.tAttach[0];
                    },
                    tAttachId: function () {
                        //return null;
                        return vm.tAttach[0].Id;
                    },
                    attach: function () {
                        return item;
                    },
                    //lista: function () {
                    //    return vm.list.attach;
                    //}
                    dipendenteId: function () {
                        return vm.record.Id;
                    },
                    tSourceCode_def: function () {
                        return vm.tSourceCode_def;
                    }
                    //tSourceCode_def: function () {
                    //    return vm.fAttach.TAttachId;
                    //}
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError($translate.instant('Errore: formato allegato non corretto'));
                if (returnItem == "400") return logError($translate.instant('Errore registrazione dati') + " " + [' + returnItem + ']);
                

                    //logSuccess('ciaoooo');
                    //getListAttach(vm.anagrafica.Id);
                    datacontext.dipendente_get(vm.record.Id).then(function (data) {
                        return vm.record = data;
                    });
                
                //vm.record.stat_numAttach = vm.record.stat_numAttach + 1;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        function deleteAttach(item) {
            var msg = " " + $translate.instant('Allegato') + " " + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError($translate.instant('Attenzione: allegato non cancellabile'));

                    var index = vm.list.attach.indexOf(item);
                    vm.list.attach.splice(index, 1);
                    //vm.record.stat_numAttach = vm.record.stat_numAttach - 1;
                });
            });
        }

        function addFirma(item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var recSource = { Id: vm.record.Id, Name: vm.record.Nominativo };

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/attach/modal/attachAddFirma.html?version=30',
                controller: 'attachAddFirma',
                windowClass: 'modal-wide',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        //return null;
                        return vm.tAttach[1];
                    },
                    tAttachId: function () {
                        //return null;
                        return vm.tAttach[1].Id;
                    },
                    attach: function () {
                        return item;
                    },
                    tSourceCode_def: function () {
                        return vm.tSourceCode_def;
                    },
                    dipendenteId: function () {
                        return vm.record.Id;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError($translate.instant('Errore: formato allegato non corretto'));
                if (returnItem == "400") return logError($translate.instant('Errore registrazione dati') + " " + [' + returnItem + ']);


                getRecord(vm.record.Id);
            }, function () {
            });
        }

    }
})();
